export interface rowData {
    id: string;
    name:string;
    email: string;
    roleName: string;
    companyName: string;
    phoneNumber: string;
    isActive: boolean;
    lastUpdatedBy: string;
    lastUpdatedAt: string;
};

export const roleDropdown = [
    'Admin',
    'User',
];
